import { useEffect, useState } from 'react';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import FilterOperatorUtmUrlInput from './FilterOperatorUtmUrlInput';
import FilterOperatorStandardUrlInput from './FilterOperatorStandardUrlInput';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { STANDARD_URL, UTM_URL, defaultUtmParameters, getFullUtmUrl } from '../../utils/urlUtils';
import FilterOperatorErrorRecord from '../../filterQueryFormat/FilterOperatorErrorRecord';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Don't use `<Text typography="body-200" />`
//   The line-height differs
//   https://git.hubteam.com/HubSpot/customer-data-filters/pull/5594/files#r4031884
const StyledSpan = styled.span.withConfig({
  displayName: "FilterOperatorUrlEqualityInput__StyledSpan",
  componentId: "und9k6-0"
})(({
  theme
}) => ({
  fontSize: theme.typography['body-200'].fontSize,
  fontWeight: theme.typography['body-200'].fontWeight
}));
export default function FilterOperatorUrlEqualityInput(props) {
  const {
    condition,
    error,
    onBlur,
    onChange,
    inputUse
  } = props;
  const initialValue = condition && condition.value;
  const isUtmUrl = condition && condition.enableTracking;
  const initialUtmUrl = condition && condition.utmBase || '';
  const initialUtmParameters = condition && condition.utmParameters || defaultUtmParameters;
  const [urlType, setUrlType] = useState(isUtmUrl ? UTM_URL : STANDARD_URL);
  const [standardUrl, setStandardUrl] = useState(!isUtmUrl && initialValue ? initialValue : '');
  const [utmUrl, setUtmUrl] = useState(isUtmUrl ? initialUtmUrl : '');
  const [utmParameters, setUtmParameters] = useState(isUtmUrl ? initialUtmParameters : defaultUtmParameters);
  const [shouldDisplayErrors, setShouldDisplayErrors] = useState(true);
  useEffect(() => {
    if (isUtmUrl) {
      setUrlType(UTM_URL);
      setStandardUrl('');
      setUtmUrl(initialUtmUrl);
      setUtmParameters(initialUtmParameters);
    } else {
      setUrlType(STANDARD_URL);
      setStandardUrl(initialValue || '');
      setUtmUrl('');
      setUtmParameters(defaultUtmParameters);
    }
  }, [initialUtmParameters, initialUtmUrl, initialValue, isUtmUrl]);
  const onChangeStandard = (evt, newShouldDisplayErrors = true) => {
    onChange(syntheticEvent(condition.set('value', evt.target.value).set('enableTracking', false).set('utmBase', '').set('utmParameters', defaultUtmParameters)));
    setShouldDisplayErrors(newShouldDisplayErrors);
  };
  const onChangeUtm = (evt, newShouldDisplayErrors = true) => {
    const {
      urlBase: newUrl,
      utmParameters: newUtmParameters
    } = evt.target.value;
    onChange(syntheticEvent(condition.set('value', getFullUtmUrl(newUrl, newUtmParameters)).set('enableTracking', true).set('utmBase', newUrl).set('utmParameters', newUtmParameters)));
    setShouldDisplayErrors(newShouldDisplayErrors);
  };
  const onChangeToStandard = () => {
    onChangeStandard(syntheticEvent(standardUrl), false);
  };
  const onChangeToUtm = () => {
    onChangeUtm(syntheticEvent({
      urlBase: utmUrl,
      utmParameters: Object.assign({}, defaultUtmParameters)
    }), false);
  };
  const sharedProps = {
    error: shouldDisplayErrors ? error : FilterOperatorErrorRecord(),
    onBlur,
    inputUse
  };
  return /*#__PURE__*/_jsxs(ToggleGroup, {
    name: "Url-type-selection",
    children: [/*#__PURE__*/_jsx(RadioInput, {
      checked: urlType === STANDARD_URL,
      onChange: onChangeToStandard,
      description: /*#__PURE__*/_jsx(FilterOperatorStandardUrlInput, Object.assign({}, sharedProps, {
        disabled: urlType !== STANDARD_URL,
        onChange: onChangeStandard,
        value: standardUrl || ''
      })),
      children: /*#__PURE__*/_jsx(StyledSpan, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterOperatorUrlEqualityInput.standard"
        })
      })
    }), /*#__PURE__*/_jsx(RadioInput, {
      checked: urlType === UTM_URL,
      onChange: onChangeToUtm,
      description: /*#__PURE__*/_jsx(FilterOperatorUtmUrlInput, Object.assign({}, sharedProps, {
        disabled: urlType !== UTM_URL,
        onChange: onChangeUtm,
        value: {
          urlBase: utmUrl || '',
          utmParameters
        }
      })),
      children: /*#__PURE__*/_jsx(StyledSpan, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterOperatorUrlEqualityInput.utm"
        })
      })
    })]
  });
}